import { ErrorMapper } from '@data/_generated-api/error-mappers/types';
import { PlatformErrorDto } from '@data/_generated-api/platform-api/models/platform-error-dto';
import { Injectable } from '@angular/core';
import { err, InvalidResult } from '@common/result/Result';
import { ErrorInformation } from '@shared/models/error/error-information';
import { ErrorReason } from '@shared/models/error/error-reason';

@Injectable({
  providedIn: 'root'
})
export class UpamErrorMapper implements ErrorMapper<PlatformErrorDto> {
  map(errors: PlatformErrorDto[] | undefined): ErrorInformation[] {
    if (!errors) {
      return [ErrorInformation.serverDown()];
    }
    return errors.map(e => {
      const errorInfo = new ErrorInformation(e.message, ErrorReason.ApplicationError);
      errorInfo.errorCode = e.errorCode;
      return errorInfo;
    });
  }

  mapInvalidResult(errors: PlatformErrorDto[] | undefined): InvalidResult<ErrorInformation> {
    const mappedErrors = this.map(errors);
    return err(mappedErrors);
  }
}
